import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ManualEvaluationForm from './manual_evaluation_form';
import OfflineIntro from './offline_intro';

function extractNumbers(string) {
  return string.replace(/[^0-9]/g, '');
}
class OfflinePlayfield extends Component {
  constructor(props) {
    super(props);

    this.state = {
      manualEvaluation: { hits: 0, errors: 0, misses: 0 }
    };

    this.handleManualEvaluationChange = this.handleManualEvaluationChange.bind(
      this
    );
  }

  handleManualEvaluationChange(name, value) {
    const { manualEvaluation } = this.state;
    const { onManualEvaluation } = this.props;
    const parsedValue = parseInt(extractNumbers(value), 10) || 0;
    const newEvaluation = { ...manualEvaluation, [name]: parsedValue };
    this.setState({ manualEvaluation: newEvaluation });
    onManualEvaluation(newEvaluation);
  }

  render() {
    const { runtime, runId, exerciseId } = this.props;
    return (
      <>
        <OfflineIntro runId={runId} runtime={runtime} exerciseId={exerciseId} />
        <ManualEvaluationForm onChange={this.handleManualEvaluationChange} />
      </>
    );
  }
}

OfflinePlayfield.propTypes = {
  runtime: PropTypes.number.isRequired,
  runId: PropTypes.string.isRequired,
  exerciseId: PropTypes.string.isRequired,
  onManualEvaluation: PropTypes.func.isRequired
};

export default OfflinePlayfield;
